// Mes tâches (26 octobre 2026) : ce qu'on a confié à Zeus et qu'il refait seul.
export default {
  titre: 'Mes tâches',
  sousTitre: 'Ce que Zeus refait pour vous, à la cadence voulue',
  vide: {
    titre: 'Aucune tâche pour l’instant',
    texte: 'Demandez à Zeus un suivi régulier : « fais-moi une écoute chaque jour sur ce format, et un résumé ». Il vous la propose ici.',
  },
  choisir: 'Choisissez une tâche pour lire ses résumés et la régler.',
  statut: { proposee: 'Proposée', active: 'Active', pause: 'En pause' },
  nature: {
    ecoute_format: 'Écoute d’un format',
    ecoute_sujet: 'Écoute d’un sujet',
    sonar: 'Question au panel',
    brief: 'Le brief',
    radar: 'Le Radar',
  },
  cadence: { quotidienne: 'Chaque jour', hebdomadaire: 'Chaque semaine', mensuelle: 'Chaque mois' },
  enCours: 'Passe en cours',
  prochaine: 'Prochain résumé : {quand}',
  consigne: 'Ce que vous voulez lire :',
  activer: 'Activer',
  reprendre: 'Reprendre',
  pause: 'Mettre en pause',
  maintenant: 'Lancer une passe maintenant',
  supprimer: 'Supprimer',
  confirmer: 'Supprimer cette tâche ?',
  oui: 'Oui, supprimer',
  non: 'Annuler',
  reglages: { cadence: 'Cadence', heure: 'Résumé prêt à', email: 'Recevoir aussi par e-mail' },
  resumes: 'Les résumés',
  aucunResume: 'Pas encore de résumé : activez la tâche.',
  aucunResumeActive: 'Le premier résumé arrive à la prochaine passe.',
}
